import React, { useEffect, useRef } from "react";

const BuyWithPrime = ({ 
  SKU = "", 
  enabled 
}) => {
  const scriptRef = useRef(null);

  useEffect(() => {
    const createScript = () => {
      const script = document.createElement("script");
      script.async = true;
      script.setAttribute("fetchpriority", "high");
      script.src = "https://code.buywithprime.amazon.com/bwp.v1.js";
      document.head.appendChild(script);
      scriptRef.current = script;
    };

    const removeScript = () => {
      if (scriptRef.current) {
        document.head.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
    };

    const swapSKU = (url, newSku) => {
      const urlObj = new URL(url);
      const searchParams = new URLSearchParams(urlObj.search);
      const newSearchParams = new URLSearchParams({
        ...Object.fromEntries(searchParams),
        sku: newSku,
      });
      return `${urlObj.origin}${urlObj.pathname}?${newSearchParams}${urlObj.hash}`;
    };

    const observeIframe = () => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "childList" &&
            mutation.addedNodes &&
            mutation.addedNodes.length
          ) {
            const iframe = mutation.addedNodes[0];
            if (iframe.id === "bwpFrame") {
              iframe.src = swapSKU(iframe.src, SKU);
              observer.disconnect();
            }
          }
        });
      });

      observer.observe(document.body, { childList: true });
    };

    const iframe = document.getElementById("bwpFrame");
    if (iframe) {
      iframe.src = swapSKU(iframe.src, SKU);
    } else {
      createScript();
      observeIframe();
    }

    return () => removeScript();
  }, [SKU]);

  return (
    <div 
      className="-mt-4 float-left w-full" 
      style={{ 
        opacity: enabled.length > 0 ? "0.3" : "1",
        pointerEvents: enabled.length > 0 ? "none" : "auto",
      }}
    >
      <div
        id="amzn-buy-now"
        data-site-id="k3mhmn5a8e"
        data-widget-id="w-hrQnRniZLt2tllbA2Yd9D5"
        data-sku={`${SKU}`}
      ></div>
    </div>
  );
};

export default BuyWithPrime;
